import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useUpdateDisclaimer(wireId, newDisclaimer) {
  const common = (wId, disclaimer) => ({
    url: `/api/v1/wire/${wId}/edit/_update_disclaimer`,
    data: { disclaimer },
  });

  const [state, q] = useAxios({
    method: 'POST',
    ...common(wireId, newDisclaimer),
  }, { manual: true });

  const executeQuery = (wId, disclaimer) => q(common(wId, disclaimer));

  return [state, executeQuery];
}
